/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, {useEffect} from 'react'
import {
    Box,
    useMultiStyleConfig,
    Skeleton
} from '@salesforce/retail-react-app/app/components/shared/ui'
import ContentAsset from '../../../components/content-asset'
import {useGlobaleContext} from '../../../contexts/globale'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import useCountryDetails from '../../../hooks/use-country-details'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const footerSkeleton = () => {
    return <Skeleton width="100%" height="167px" />
}

const CheckoutFooter = () => {
    const styles = useMultiStyleConfig('CheckoutFooter')
    const {
        countryISO,
        setCurrencyContext,
        setCurrencyForGlobale,
        setCountryForGlobale,
        setCountryISOContext
    } = useGlobaleContext()
    const {data: basket, isLoading: isBasketLoading} = useCurrentBasket()
    const {
        app: {commerceAPI}
    } = getConfig()
    const {globalE} = commerceAPI
    const {config} = globalE || {}
    var geEnabled = false
    try {
        if (config) {
            const jsonConfig = JSON.parse(config)
            geEnabled = jsonConfig.enabled
        }
    } catch (e) {
        console.log(e.message)
    }
    const {data: countryData} = useCountryDetails(countryISO, {enabled: geEnabled})

    useEffect(() => {
        if (!geEnabled) {
            return
        }

        const timer = setTimeout(() => {
            // addressing the edge case. i.e. set a time out of 5 seconds so that we'll not see skeleton, spinners on the site, specifically on the cart page
            if (!countryData) {
                console.warn(
                    'countryData not available after 5 seconds, falling back to US defaults'
                )
                setCurrencyContext('USD')
                setCurrencyForGlobale('USD')
                setCountryForGlobale('US')
                setCountryISOContext('US')
            }
        }, 5000)

        return () => clearTimeout(timer)
    }, [countryData, geEnabled])

    if (!countryISO || (countryISO && countryISO !== 'US') || isBasketLoading || !basket) {
        return footerSkeleton
    }
    return (
        <Box
            as="footer"
            {...styles.container}
            {...styles.footerContent}
            className="footer-container"
        >
            <ContentAsset contentAssetId="checkout-footer" skeleton={footerSkeleton} />
        </Box>
    )
}

export default CheckoutFooter
